/**
 * * 城市分离的选择器
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @param keyLabel={"cityName"}
 * @param keyValue={"cityCode"}
 *
 * -----------------------
 * @param hasList [{
 *     cityCode => value
 *     cityName => label
 * }]
 * @param 回调 onChangeBack = [{
 *     value: cityCode
 *     label: cityName
 * }]
* */
import React, {Component} from 'react';
import { Select,Col,Row,Checkbox } from "antd";
import Lang from "@components/Lang/Lang";
import "./index.less";

export default class CitySelect extends Component {
    static defaultProps = {
        list:[],
        keyValue:"cityCode",
        keyLabel :"cityName",
        placeholder:""
    }
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            // optionList: [],
            hasList: [],//可能出现 不在 list 的内容，所有不受限
            changeAll:false,//默认不全选
        }
    }
    // 多选下是数组
    handleChange(values=[], options=[]){
        // console.log("多选下是数组value",value,options)
        if(values.length>0&&options.length>0) {
            const value = values[0], option = options[0];
            let {hasList, } = this.state;
            const {keyValue} = this.props;
            // console.log("多选下是数组valueList",valueList,option)
            const inx = hasList.findIndex(item => item[keyValue] == value);
            if (inx < 0) {
                hasList.push(option)
                if(this.props.onChangeBack)this.props.onChangeBack(hasList)
                console.log("hasList",hasList,)
                this.setState({
                    hasList: hasList,
                })
            }
        }
    }
    handleDelete(value){
        const {keyValue} = this.props;
        let { hasList } = this.state;
        hasList = hasList.filter(item=>item[keyValue]!==value);
        console.log("hasList",hasList)
        if(this.props.onChangeBack)this.props.onChangeBack(hasList)
        this.setState({
            hasList:hasList
        })
    }
    onChangeAll(checked){
        let { hasList, } = this.state;
        const {keyValue,list} = this.props;
        if(checked){
            list.forEach((option,index)=>{ // 添加当前国家所有城市
                const inx = hasList.findIndex(val => option[keyValue] == val[keyValue]);
                if (inx < 0) {
                    // hasList.push({
                    //     value: option.value,
                    //     label: option.label,
                    // })
                    hasList.push(option)
                }
            })
        }else {// 添加当前国家所有城市
            list.forEach((option,index)=>{
                hasList = hasList.filter(item=>item[keyValue]!==option[keyValue]);
            })
        }
        if(this.props.onChangeBack)this.props.onChangeBack(hasList)
        this.setState({
            hasList: hasList,
            changeAll:checked
        })
    }
    init(){
        const {keyValue,keyLabel,hasList} = this.props;
        // let children = [];
        // let initHasList = [];
        // list.forEach(item=>{
        //     children.push({
        //         value:item[keyValue],
        //         label: item[keyLabel],
        //     })
        // })
        // hasList.forEach(item=>{
        //     initHasList.push({
        //         value:item[keyValue],
        //         label: item[keyLabel],
        //     })
        // })
        console.log("hasList",hasList)
        this.setState({
            // optionList: list,
            changeAll:false,
            hasList: hasList,
        })
    }
    // 重置 数据
    reInit(){
        this.setState({
            changeAll:false,
        })
    }
    componentDidMount() {
        this.init();
        if( this.props.onRef)this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const {title,placeholder,keyValue,keyLabel,list} = this.props;
        const {hasList, changeAll} = this.state;
        return (<div className={"labelSeparateSelect"}>
            {title&&<div className={"black100 mb_8"}>{title}</div>}
            <Row gutter={8}>
                <Col span={list.length>0?16:24}>
                    <Select mode="multiple"
                            fieldNames={{label:keyLabel,value:keyValue}}
                            placement={"topLeft"}
                            value={[]}
                            size="large"
                            optionFilterProp="label"
                            filterOption={(input, option) => (option?.cityName ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.cityName ?? '').toLowerCase().localeCompare((optionB?.cityName ?? '').toLowerCase())
                            }
                            onChange={(value, option)=>this.handleChange(value, option)}
                            placeholder = {placeholder}
                            options={list}
                            style={{width:"100%"}}
                        />
                </Col>
                {list.length>0?<Col span={8}>
                    <Checkbox className={"checkInput"} checked={changeAll}
                              onChange={(e)=>this.onChangeAll(e.target.checked)}>{Lang({id:"QuanBu",default:"全部"})}</Checkbox>
                </Col>:null}
            </Row>
            <div className={"flex-item"}>
                {hasList.map((item,inx)=><span className={"label"}
                                               onClick={()=>this.handleDelete(item[keyValue])}
                                               key={inx}>
                    {item[keyLabel]}<i className="ri-close-line ml_16"></i>
                </span>)}
            </div>
        </div>)
    }
}